import React from 'react';
import '../constants/AssetsCss';
class ActiveTeamList extends React.Component {
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! Test</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Active Team List</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 row">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Active Team List</h3>
                        </div>
                        <div className="d-md-flex mt-4 mb-2">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <input type="date" className="form-control daterange-single" id="start_date" name="start_date" placeholder="From Date" autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <input type="date" className="form-control daterange-single" id="end_date" name="end_date" placeholder="To Date" autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-left">
                                <div className="form-group">
                                    <button type="submit" className="btn bg-color-1" style={{color:"white"}}> View Business </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 row ml-1">
                            <div className="card col-lg-6 col-md-12">
                                <div className="card-header">
                                    <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Left Team</h3>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                            <thead className="">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Member ID</th>
                                                    <th>Investment</th>
                                                    <th>Date</th>
                                                    <th>Sponsor ID</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="bg-color-1" style={{ color: "white" }}>1</td>
                                                    <td>22/06/2022</td>
                                                    <td>50</td>
                                                    <td>9%</td>
                                                    <td>30</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card col-lg-6 col-md-12">
                                <div className="card-header">
                                    <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Right Team</h3>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                            <thead className="">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Member ID</th>
                                                    <th>Investment</th>
                                                    <th>Date</th>
                                                    <th>Sponsor ID</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="bg-color-1" style={{ color: "white" }}>1</td>
                                                    <td>22/06/2022</td>
                                                    <td>50</td>
                                                    <td>9%</td>
                                                    <td>30</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default ActiveTeamList;